export interface AnimeItem {
  id: string;
  title: string;
  cover: string;
  banner: string;
  synopsis: string;
  description: string[];
  genre: string[];
  region: string;
  year: number;
  status: string;
  studio: string;
  rating: number;
  episodes: number;
  tags: string[];
  updatedAt: string;
  popularity: number;
}

export const animeList: AnimeItem[] = [
  {
    id: "blade-echo",
    title: "剑鸣回响",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20young%20swordsman%20holding%20a%20glowing%20katana%2C%20dramatic%20orange%20sunset%20sky%2C%20wind%20blowing%20cloak%2C%20detailed%20cel%20shaded%20illustration%2C%20warm%20toned%20background%2C%20high%20detail&width=600&height=800&seq=anime-cover-blade-echo&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20anime%20landscape%20battlefield%20at%20dusk%20with%20glowing%20sword%20light%20trails%2C%20warm%20orange%20and%20amber%20tones%2C%20cinematic%20cel%20shaded%20background%20art%2C%20painterly%20sky&width=1600&height=900&seq=anime-banner-blade-echo&orientation=landscape",
    synopsis: "一位失去记忆的少年剑士，在战火纷飞的乱世中追寻自己的身世，也追寻剑道真正的回响。",
    description: [
      "《剑鸣回响》以架空的和风战国为舞台，讲述少年剑士凛在一次濒死对决中失去记忆，被隐居的铸剑师收留。为了找回过去，他踏上了寻找「鸣剑」的旅途。",
      "作品以凌厉的分镜和极具张力的战斗演出著称，同时用大量笔墨刻画角色的孤独与羁绊。每一场战斗不仅是力量的碰撞，更是信念的对话。",
      "配乐由知名作曲家操刀，和乐器与交响乐的结合让整部作品的氛围层次分明，被观众称为「会呼吸的武侠」。"],
    genre: ["战斗", "奇幻", "剧情"],
    region: "日本",
    year: 2025,
    status: "连载中",
    studio: "白露动画工房",
    rating: 9.1,
    episodes: 24,
    tags: ["热血", "和风", "剑戟", "复仇"],
    updatedAt: "2026-10-14",
    popularity: 9860,
  },
  {
    id: "star-voyage",
    title: "星海彼端",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20astronaut%20girl%20floating%20in%20deep%20space%20surrounded%20by%20stars%20and%20spaceship%2C%20warm%20orange%20nebula%20accents%2C%20cel%20shaded%20illustration%2C%20clean%20simple%20background%2C%20high%20detail&width=600&height=800&seq=anime-cover-star-voyage&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=vast%20anime%20space%20landscape%20with%20distant%20planet%20and%20starship%20trail%2C%20warm%20amber%20nebula%20glow%2C%20cinematic%20cel%20shaded%20background%20art%2C%20deep%20blue%20tones%20with%20orange%20highlights&width=1600&height=900&seq=anime-banner-star-voyage&orientation=landscape",
    synopsis: "当人类把最后一艘方舟飞船送往星海彼端，一群少年背负着全人类的希望，也背负着无人知晓的秘密。",
    description: [
      "《星海彼端》是一部硬科幻设定的冒险动画。故事发生在人类母星资源枯竭后的第两百年，方舟「回声号」正驶向一颗疑似宜居的行星。",
      "作品世界观构建严谨，从舰船动力、生态循环到社会结构都有细致设定，同时用少年们的成长故事串联起宏大的宇宙叙事。",
      "视觉上以深邃的星海与温暖的船舱灯光形成强烈对比，强调「冰冷宇宙中的人性温度」这一核心主题。"],
    genre: ["科幻", "冒险", "剧情"],
    region: "日本",
    year: 2025,
    status: "连载中",
    studio: "星轨制作组",
    rating: 8.9,
    episodes: 22,
    tags: ["太空", "群像", "成长", "硬科幻"],
    updatedAt: "2026-10-15",
    popularity: 9120,
  },
  {
    id: "paper-crane",
    title: "千纸之愿",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20girl%20folding%20origami%20cranes%20by%20sunlit%20window%2C%20soft%20warm%20light%2C%20gentle%20healing%20atmosphere%2C%20pastel%20cream%20background%2C%20cel%20shaded%20illustration%2C%20high%20detail&width=600&height=800&seq=anime-cover-paper-crane&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=serene%20anime%20room%20with%20hanging%20origami%20cranes%20and%20warm%20afternoon%20sunlight%2C%20soft%20cream%20and%20amber%20tones%2C%20painterly%20cel%20shaded%20background%2C%20cozy%20healing%20mood&width=1600&height=900&seq=anime-banner-paper-crane&orientation=landscape",
    synopsis: "一叠彩纸、一千只纸鹤、一个关于告别的约定——温柔叙事下的生命哲思。",
    description: [
      "《千纸之愿》讲述了住院少女小满与沉默少年阿司之间的故事。小满相信折满一千只纸鹤就能实现一个愿望，而阿司成了她每天的陪伴。",
      "作品几乎全部发生在医院与小镇的场景中，却用细腻的日常细节和克制的演出打动人心。它不去刻意煽情，而是让观众自己体会「活着」的重量。",
      "每一集都以一只纸鹤的折起作为结尾，既是叙事节奏，也是情感的沉淀，被评价为「一集一滴眼泪，却让人充满力量」。"],
    genre: ["治愈", "剧情", "校园"],
    region: "日本",
    year: 2025,
    status: "连载中",
    studio: "暖阳工作室",
    rating: 9.0,
    episodes: 12,
    tags: ["治愈", "催泪", "日常", "成长"],
    updatedAt: "2026-10-12",
    popularity: 8730,
  },
  {
    id: "painted-sky",
    title: "绘空之城",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20floating%20city%20painted%20with%20ink%20brush%2C%20artist%20girl%20on%20rooftop%2C%20chinese%20ink%20painting%20aesthetic%2C%20warm%20orange%20accents%2C%20cel%20shaded%20illustration%2C%20high%20detail&width=600&height=800&seq=anime-cover-painted-sky&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=sweeping%20anime%20panorama%20of%20a%20floating%20city%20made%20of%20ink%20strokes%20in%20the%20clouds%2C%20chinese%20watercolor%20aesthetic%2C%20warm%20orange%20sunlight%2C%20painterly%20cel%20shaded%20background&width=1600&height=900&seq=anime-banner-painted-sky&orientation=landscape",
    synopsis: "一支可以「画出真实」的毛笔，让少女得以修补破碎的浮空之城，也修补自己破碎的家。",
    description: [
      "《绘空之城》是国产动画中少见的将水墨美学与奇幻设定结合的作品。主角小釉继承了一支传说中的画笔，能把画出的东西变成现实。",
      "故事围绕她修复逐渐崩塌的浮空之城展开，每一次挥毫都是一次选择：修补世界，还是修补自己失去的家人。",
      "作品的水墨质感背景与流畅的转场设计广受好评，登顶周榜的同时也引发了关于「国风动画新表达」的讨论。"],
    genre: ["奇幻", "治愈", "冒险"],
    region: "中国",
    year: 2025,
    status: "连载中",
    studio: "水墨映画",
    rating: 8.7,
    episodes: 16,
    tags: ["国风", "水墨", "奇幻", "亲情"],
    updatedAt: "2026-10-13",
    popularity: 8460,
  },
  {
    id: "spirit-eater",
    title: "灵食猎人",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20young%20hunter%20with%20glowing%20food%20dish%20and%20spirit%20creature%2C%20energetic%20action%20pose%2C%20warm%20orange%20flames%2C%20cel%20shaded%20illustration%2C%20simple%20background%2C%20high%20detail&width=600&height=800&seq=anime-cover-spirit-eater&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=dynamic%20anime%20scene%20of%20a%20hunter%20cooking%20with%20magical%20glowing%20flames%20in%20a%20night%20market%2C%20warm%20orange%20lantern%20glow%2C%20cinematic%20cel%20shaded%20background&width=1600&height=900&seq=anime-banner-spirit-eater&orientation=landscape",
    synopsis: "在这个世界，魔物会以「食」为媒介寄生。唯一能净化它们的，是一种名为「灵食」的料理。",
    description: [
      "《灵食猎人》将热血战斗与美食元素巧妙融合。主角燎是一名天赋异禀的灵食猎人，靠着一手出神入化的厨艺净化被魔物侵蚀的灵魂。",
      "每一集围绕一道料理展开，料理背后的情感故事与战斗场面交替推进，让作品既有爽感也有温度。",
      "新章中主线迎来最大转折，燎的身世之谜逐渐揭开，剧情走向从单元剧转向了更大的格局。"],
    genre: ["冒险", "热血", "奇幻"],
    region: "日本",
    year: 2024,
    status: "连载中",
    studio: "烈焰社",
    rating: 8.8,
    episodes: 38,
    tags: ["美食", "热血", "战斗", "单元剧"],
    updatedAt: "2026-10-15",
    popularity: 8240,
  },
  {
    id: "moonlit-lane",
    title: "月巷迷踪",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20detective%20boy%20standing%20in%20a%20narrow%20old%20alley%20lit%20by%20moonlight%20and%20lanterns%2C%20mysterious%20mood%2C%20warm%20amber%20highlights%2C%20cel%20shaded%20illustration%2C%20high%20detail&width=600&height=800&seq=anime-cover-moonlit-lane&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=atmospheric%20anime%20night%20alley%20in%20an%20old%20town%20with%20paper%20lanterns%20and%20mist%2C%20warm%20orange%20lantern%20glow%20against%20cool%20shadows%2C%20painterly%20cel%20shaded%20background&width=1600&height=900&seq=anime-banner-moonlit-lane&orientation=landscape",
    synopsis: "一条只在月圆之夜出现的老巷，一桩跨越三十年的悬案，少年侦探必须在真相被月光抹去前揭开它。",
    description: [
      "《月巷迷踪》是一部带有东方民俗色彩的推理动画。主角辰是一名少年侦探，因一封神秘来信来到名为「月巷」的古镇。",
      "作品结构精巧，采用双线叙事，现实调查与三十年前的往事交织推进，每一集结尾都留下让人欲罢不能的悬念。",
      "结局采用开放式处理，引发了观众对真相的大量解读，成为当年讨论度最高的国产推理番之一。"],
    genre: ["悬疑", "推理", "剧情"],
    region: "中国",
    year: 2024,
    status: "已完结",
    studio: "月影影业",
    rating: 8.6,
    episodes: 20,
    tags: ["推理", "民俗", "悬疑", "双线叙事"],
    updatedAt: "2026-08-20",
    popularity: 7980,
  },
  {
    id: "echo-garden",
    title: "回声花园",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20girl%20playing%20violin%20in%20a%20flower%20garden%20at%20golden%20hour%2C%20youthful%20emotional%20mood%2C%20warm%20orange%20sunlight%2C%20cel%20shaded%20illustration%2C%20high%20detail&width=600&height=800&seq=anime-cover-echo-garden&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=emotional%20anime%20scene%20of%20a%20school%20music%20room%20at%20sunset%20with%20violin%20and%20sheet%20music%2C%20warm%20orange%20golden%20hour%20light%2C%20painterly%20cel%20shaded%20background&width=1600&height=900&seq=anime-banner-echo-garden&orientation=landscape",
    synopsis: "一群少年用音乐寻找彼此的回声，在青春的噪音里，奏出属于自己的旋律。",
    description: [
      "《回声花园》是一部青春音乐题材的动画。故事围绕一所高中的音乐社团展开，五名性格迥异的少年因为一次意外聚到一起。",
      "作品对音乐演奏的演出极为讲究，每一场合奏都配合精心的分镜与音效，让观众仿佛置身现场。",
      "除了音乐，作品也认真探讨了青春期的迷茫、天赋与努力的命题，被评价为「不只听到旋律，更听到心跳」。"],
    genre: ["音乐", "青春", "校园"],
    region: "日本",
    year: 2024,
    status: "已完结",
    studio: "回响工作室",
    rating: 8.7,
    episodes: 13,
    tags: ["音乐", "青春", "群像", "治愈"],
    updatedAt: "2026-07-30",
    popularity: 7620,
  },
  {
    id: "cherry-blossom",
    title: "樱花时雨",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20two%20high%20school%20students%20under%20falling%20cherry%20blossoms%20petals%2C%20romantic%20spring%20atmosphere%2C%20soft%20warm%20light%2C%20cel%20shaded%20illustration%2C%20high%20detail&width=600&height=800&seq=anime-cover-cherry-blossom&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=romantic%20anime%20school%20path%20lined%20with%20blooming%20cherry%20trees%20at%20spring%20dusk%2C%20soft%20pink%20and%20warm%20orange%20light%2C%20painterly%20cel%20shaded%20background&width=1600&height=900&seq=anime-banner-cherry-blossom&orientation=landscape",
    synopsis: "一场春雨、一树樱花、一段没能说出口的心意——关于青春里最纯粹的那次心动。",
    description: [
      "《樱花时雨》是一部典型的青春恋爱动画，讲述了转学生咲与图书委员悠之间从误会到相知的故事。",
      "作品节奏舒缓，用大量细节刻画少男少女的细腻心思，没有狗血桥段，只有真实到让人会心一笑的日常。",
      "剧场版预告释出后，粉丝们对新故事的期待值瞬间拉满，被认为是最治愈的青春恋爱番之一。"],
    genre: ["爱情", "校园", "青春"],
    region: "日本",
    year: 2024,
    status: "已完结",
    studio: "春野动画",
    rating: 8.5,
    episodes: 13,
    tags: ["恋爱", "青春", "治愈", "日常"],
    updatedAt: "2026-06-18",
    popularity: 7340,
  },
  {
    id: "neon-district",
    title: "霓虹街区",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20cyberpunk%20city%20street%20with%20neon%20signs%20and%20a%20lone%20figure%20in%20rain%2C%20orange%20neon%20glow%20accents%2C%20cel%20shaded%20illustration%2C%20high%20detail&width=600&height=800&seq=anime-cover-neon-district&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=rainy%20cyberpunk%20anime%20cityscape%20at%20night%20with%20glowing%20orange%20neon%20signs%20and%20wet%20streets%2C%20cinematic%20cel%20shaded%20background%2C%20moody%20atmosphere&width=1600&height=900&seq=anime-banner-neon-district&orientation=landscape",
    synopsis: "在被数据统治的霓虹街区，记忆可以被买卖，而一名跑腿少年决定赎回不属于自己的那段记忆。",
    description: [
      "《霓虹街区》是一部赛博朋克风格的科幻动画。故事设定在一座由巨型企业控制的未来都市，人的记忆可以存储与交易。",
      "主角洛是一名游走于街区的「记忆跑腿」，一次意外让他接触到一段不该存在的记忆，从而卷入巨大的阴谋。",
      "作品在视觉上极具风格，雨夜、霓虹与老街的混搭营造出独特的赛博质感，配乐以电子音为主，氛围感拉满。"],
    genre: ["科幻", "赛博", "悬疑"],
    region: "日本",
    year: 2022,
    status: "已完结",
    studio: "夜灯制作",
    rating: 8.4,
    episodes: 18,
    tags: ["赛博朋克", "科幻", "悬疑", "反乌托邦"],
    updatedAt: "2026-05-10",
    popularity: 6980,
  },
  {
    id: "dragon-chef",
    title: "龙厨奇谭",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20cheerful%20young%20chef%20cooking%20with%20a%20small%20friendly%20dragon%2C%20colorful%20ingredients%20flying%2C%20warm%20orange%20kitchen%20light%2C%20cel%20shaded%20illustration%2C%20high%20detail&width=600&height=800&seq=anime-cover-dragon-chef&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=warm%20animated%20kitchen%20scene%20with%20a%20young%20chef%20and%20a%20cute%20dragon%20assistant%20cooking%2C%20warm%20orange%20flames%20and%20cozy%20light%2C%20painterly%20cel%20shaded%20background&width=1600&height=900&seq=anime-banner-dragon-chef&orientation=landscape",
    synopsis: "一个立志成为天下第一厨师的少年，和一条只会吃的龙，开着一辆餐车周游世界。",
    description: [
      "《龙厨奇谭》是一部轻松搞笑的美食冒险动画。主角小饱带着一条意外收留的小龙「咕噜」，驾着餐车环游各地。",
      "每一集都会遇到不同的食客与挑战，料理的胜负往往不是靠技巧，而是靠对食客的理解与真心。",
      "作品画风温暖明亮，美食作画极为诱人，是下饭番中的新宠。"],
    genre: ["美食", "搞笑", "冒险"],
    region: "中国",
    year: 2025,
    status: "连载中",
    studio: "食光社",
    rating: 8.2,
    episodes: 12,
    tags: ["美食", "搞笑", "治愈", "冒险"],
    updatedAt: "2026-10-11",
    popularity: 6480,
  },
  {
    id: "mecha-dawn",
    title: "机甲黎明",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20giant%20mecha%20robot%20standing%20at%20sunrise%20with%20pilot%20silhouette%2C%20dramatic%20warm%20orange%20sky%2C%20cel%20shaded%20illustration%2C%20high%20detail&width=600&height=800&seq=anime-cover-mecha-dawn&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20anime%20scene%20of%20a%20giant%20humanoid%20mecha%20on%20a%20war%20torn%20field%20at%20dawn%2C%20warm%20orange%20sunrise%20light%2C%20cinematic%20cel%20shaded%20background&width=1600&height=900&seq=anime-banner-mecha-dawn&orientation=landscape",
    synopsis: "当最后一批机甲驾驶员踏上黎明前线的战场，他们守护的究竟是家园，还是制造战争的机器。",
    description: [
      "《机甲黎明》是一部经典的机战题材动画，讲述了少年驾驶员们在人类与神秘敌人「黯潮」的战争中的成长与抉择。",
      "作品对战机的机械设定极为考究，每台机体都有独立的性能与背景；战斗演出以高速剪辑与厚重质感著称。",
      "十周年之际，这部作品依然被许多观众视为机战番的时代标杆，「黎明」一词也成了粉丝之间的暗号。"],
    genre: ["科幻", "机战", "剧情"],
    region: "日本",
    year: 2023,
    status: "已完结",
    studio: "钢铁映画",
    rating: 8.3,
    episodes: 26,
    tags: ["机甲", "科幻", "战争", "热血"],
    updatedAt: "2026-04-22",
    popularity: 6120,
  },
  {
    id: "crystal-dance",
    title: "晶石物语",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20magical%20girl%20holding%20glowing%20crystal%20gems%2C%20fantasy%20adventure%20mood%2C%20warm%20orange%20and%20amber%20magic%20light%2C%20cel%20shaded%20illustration%2C%20high%20detail&width=600&height=800&seq=anime-cover-crystal-dance&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=fantasy%20anime%20landscape%20with%20giant%20floating%20glowing%20crystals%20over%20a%20valley%2C%20warm%20amber%20magic%20glow%2C%20painterly%20cel%20shaded%20background&width=1600&height=900&seq=anime-banner-crystal-dance&orientation=landscape",
    synopsis: "在晶石决定一切的世界里，一个没有任何晶石天赋的少女，却握住了改变世界的钥匙。",
    description: [
      "《晶石物语》是一部欧美出品的奇幻冒险动画。故事发生在一个由晶石之力维系的大陆，人人都与晶石共鸣。",
      "主角艾拉是唯一无法共鸣晶石的异类，却意外唤醒了一块远古晶核，从而踏上寻找真相的旅程。",
      "作品以丰富的异世界建筑与生物设计见长，画面色彩饱和明亮，是近年来少有的欧美奇幻佳作。"],
    genre: ["奇幻", "冒险", "成长"],
    region: "欧美",
    year: 2023,
    status: "已完结",
    studio: "Crystal Works",
    rating: 7.9,
    episodes: 24,
    tags: ["奇幻", "异世界", "成长", "冒险"],
    updatedAt: "2026-03-15",
    popularity: 5640,
  },
];